import { AuthService } from "@js/services/AuthService";
import { ApplicationUser, LicenseMasterStatusEnum } from "@src/apis/ModularClient";
import { IndexService } from "@js/services/IndexService";

export class LeadGenPromoController {
  static $inject = ["$routeParams", "$location", "IndexService"];

  licenseCount: number = 0;
  showAddLaterButton: boolean = true;

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private indexService: IndexService,
  ) {
    if (this.$routeParams.licensecount) {
      this.licenseCount = this.$routeParams.licensecount;
    }
  }

  async addLaterClicked() {
    const subscriptionStatus = (await this.indexService.currentUserLicenseData).subscriptionStatus;
    if (
      this.licenseCount > 1 &&
      (subscriptionStatus == LicenseMasterStatusEnum.PaidUp ||
        subscriptionStatus == LicenseMasterStatusEnum.PaymentProcessing)
    ) {
      this.$location.path("/assignlicenses");
    } else {
      this.$location.path("/userdashboard");
    }
  }

  bookCall() {
    window.open("https://brickflow.com/brokers/brickflow-enterprise/book-a-demo");
  }
}
